import carIcon from '@assets/images/icons/icon-car-info-grey.svg';
import motoIcon from '@assets/images/icons/icon-moto-info-grey.svg';

export { carIcon, motoIcon };

const VEHICLE_IMAGE_SIZE_PARAMS = '?s=fill&w=391&h=279&q=70&t=true';

export const isCar = (vehicleType: string): boolean => vehicleType === 'Car';

/** URL da foto do veículo para lista/header, com fallback para ícone. */
export const getVehicleImageUrl = (
  photoPath: string | null | undefined,
  vehicleType: string,
): string => {
  if (photoPath) {
    return `${import.meta.env.VITE_URL_FOTO_PEQUENA}${photoPath.replaceAll('\\', '/')}${VEHICLE_IMAGE_SIZE_PARAMS}`;
  }
  return isCar(vehicleType) ? carIcon : motoIcon;
};

/** URL da foto do veículo para mensagem (base URL diferente por tipo, sem fallback). */
export const getVehicleMessageImageUrl = (
  photoPath: string | null | undefined,
  vehicleType: string,
): string | false => {
  if (!photoPath) return false;
  const baseUrl = isCar(vehicleType)
    ? import.meta.env.VITE_URL_FOTO_PEQUENA
    : import.meta.env.VITE_URL_FOTO_PEQUENA_MOTO;
  return `${baseUrl}${photoPath.replaceAll('\\', '/')}${VEHICLE_IMAGE_SIZE_PARAMS}`;
};
